export const ExodusResources = {
    ORGANIZATION: '/api/organization',
    MEDICALCONDITIONCATEGORY: '/api/masterdata/medical-condition-category',
    MEDICALCONDITION: '/api/masterdata/medical-condition',
    CONSULTATION : '/api/masterdata/consultation',
    LABTEST : '/api/masterdata/labtest',
    LABTESTCATEGORY : '/api/masterdata/labtestcategory',
    PRODUCT : '/api/masterdata/product',
    PRODUCTCATEGORY : '/api/masterdata/productcategory',
    PRESCRIPTION : '/api/masterdata/prescription',
    PRESCRIPTIONCATEGORY : '/api/masterdata/prescriptioncategory',
    VACCINE : '/api/masterdata/vaccine',
    CLINIC : '/api/masterdata/centreclinic',
    CLINICTYPE : '/api/masterdata/clinictype',
    REASON : '/api/masterdata/reason',
    GROUPTEMPLATE: '/api/grouptemplate'
};



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/shared/urls/exodus.resource.ts